// extracted by mini-css-extract-plugin
module.exports = {"why-us":"WhyUs_why-us__5u9Er","all-content":"WhyUs_all-content__qshfQ","container":"WhyUs_container__QK6sN","space-bottom-desk":"WhyUs_space-bottom-desk__Wfm9L"};